/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-has-content */
import { useState } from "react";
import { Menu, MenuItem, Sidebar } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import clients from "../icons/clients.svg";
import home from "../icons/home.svg";
import photo from "../icons/photos-icon.svg";
import logoFull from "../icons/mooda_logo_full.svg";
import logoIcon from "../icons/mooda_logo_icon.svg";
import orderIcon from "../icons/orderIcon.svg";
import products from "../icons/products.svg";
import cifrao from "../icons/cifrao.svg";
import carrinho from "../icons/cartIconWhite.svg";
import mobile from "../icons/mobile.svg";
import discount from "../icons/discount.svg";
import cashback from "../icons/cashback.svg";
import { useCompany } from "../components/context/CompanyContext";
import { useSidebar } from "./context/SidebarContext";
import { resolveUrlMooda } from "../requestMethods";
import { canAccessScreen } from "../util/accessControl";
import { useSelector } from "react-redux";
import whatsAppIcon from "../icons/whatsAppIcon.svg";
import "./sidebarComponent.css";

export default function SidebarComponent() {
  const { collapsed, setCollapsed } = useSidebar();
  const [mobileOpen, setMobileOpen] = useState(false);
  // accessControl vem do CompanyContext (mesma fonte da guarda de rota), para
  // que menu e rota nunca discordem sobre o que o perfil pode ver.
  const { slug, showDashboard, enabledPayment, showCashback, accessControl, isRetail } =
    useCompany();
  const currentUser = useSelector((state) => state.user.currentUser);

  const urlBase = resolveUrlMooda(isRetail, slug);
  const url = urlBase + "home";
  const urlEmployee = urlBase + "employee";

  const menuItems = [
    { label: "Home", icon: home, link: "homev2" },
    { label: "Clientes", icon: clients, link: "customers" },
    { label: "Pedidos", icon: orderIcon, link: "orders" },
    { label: "Carrinhos", icon: carrinho, link: "cartlist" },
    { label: "Produtos", icon: products, link: "products" },
    { label: "Cupom Desc.", icon: discount, link: "discounts" },
    { label: "Cashback", icon: cashback, link: "cashback", show: showCashback },
    { label: "Campanha", icon: products, link: "campaign" },
    { label: "Acervo", icon: photo, link: "collection" },
    { label: "MoodaChat", icon: whatsAppIcon, link: "chatbot" },
    { label: "Notificações", icon: mobile, link: "push" },
    {
      label: "Smart Look IA",
      iconComponent: (
        <AutoAwesomeIcon style={{ color: "white", fontSize: 20 }} />
      ),
      link: "virtual/showcase",
    },
    {
      label: "Extrato",
      icon: cifrao,
      link: "paymentReport",
      show: enabledPayment,
    },
    {
      label: "ADS",
      iconComponent: <AdsClickIcon style={{ color: "white", fontSize: 20 }} />,
      link: "indicadoresclientes?ads=1",
    },
    { label: "Mobile", icon: mobile, externalLink: url },
    { label: "Vendedor(a)", icon: mobile, externalLink: urlEmployee },
  ];

  function returnPosition() {
    if (currentUser && currentUser.position) {
      return currentUser.position;
    }
    return undefined;
  }
  const renderMenu = (isCollapsed) => (
    <Menu
      menuItemStyles={{ icon: { padding: "0px" } }}
      rootStyles={{
        backgroundImage: "linear-gradient(to right, #FF3131, #FF914C)",
      }}
    >
      <MenuItem>
        <div className={isCollapsed ? "customLogoIcon" : "customLogo"}>
          <img src={isCollapsed ? logoIcon : logoFull} />
        </div>
      </MenuItem>

      {menuItems.map((item, index) => {
        if (item.show === false) return null;
        if (!canAccessScreen(accessControl, returnPosition(), item.label))
          return null;

        return (
          <MenuItem
            key={index}
            icon={item.iconComponent ?? <img src={item.icon} />}
            component={
              item.externalLink ? (
                <a
                  href={item.externalLink}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ) : (
                <Link to={item.link} onClick={() => setMobileOpen(false)} />
              )
            }
          >
            {item.label}
          </MenuItem>
        );
      })}
    </Menu>
  );

  return (
    <>
      {/* Hambúrguer — visível apenas no mobile */}
      <button
        className="sidebar-hamburger"
        onClick={() => setMobileOpen(true)}
        aria-label="Abrir menu"
      >
        &#9776;
      </button>

      {/* Backdrop mobile */}
      {mobileOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Drawer mobile */}
      <div
        className={`sidebar-mobile-drawer ${mobileOpen ? "sidebar-mobile-drawer--open" : ""}`}
      >
        <button
          className="sidebar-mobile-close"
          onClick={() => setMobileOpen(false)}
          aria-label="Fechar menu"
        >
          &times;
        </button>
        {renderMenu(false)}
      </div>

      {/* Sidebar desktop (fixa; overlay ao expandir no hover) */}
      <div
        className="sidebar-desktop"
        onMouseEnter={() => setCollapsed(false)}
        onMouseLeave={() => setCollapsed(true)}
      >
        <Sidebar
          width="200px"
          collapsed={collapsed}
          collapsedWidth="60px"
          rootStyles={{
            height: "100vh",
            border: "none",
            boxShadow: collapsed ? "none" : "2px 0 8px rgba(0,0,0,0.2)",
          }}
          backgroundColor="transparent"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              backgroundImage: "linear-gradient(to right, #FF3131, #FF914C)",
            }}
          >
            {renderMenu(collapsed)}
          </div>
        </Sidebar>
      </div>
    </>
  );
}
